import React from "react";
import { Link } from "react-router-dom";

const ContactUs = () => {
  return (
    <section className="contactus">
      <div className="container">
        <h1 className="pageTitle">Contact <span>Us</span></h1>
        <div className="contact-wrapper">
          <form className="contact-form">
            <input type="text" placeholder="Name" />
            <input type="email" placeholder="Email" />
            <input type="text" placeholder="Subject" />
            <textarea placeholder="Type your message"></textarea>
            <input type="submit" value="Send Message"/>
          </form>
          <div className="contact-right">
            <div className="contact-right-content">
              <h2>CONTACT INFO</h2>
              <p>
                Choose one of the alterntive methods of communication.
                We’reavailable Form Monday to Friday.
              </p>
              <div className="contact-details">
                <span>
                  Office:
                  <Link to="" className="contact-item">
                    249 Ung Van Khiem St,Binh ThanHDist,Us
                  </Link>
                </span>
                <span>
                  Phone:
                  <Link to="tel:(08 8827 63335)" className="contact-item">
                    (08) 8827 63335
                  </Link>
                </span>
                <span>
                  Email:
                  <Link to="" className="contact-item">
                    owner@example.com
                  </Link>
                </span>
              </div>
            </div>
            <div className="contact-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14602.250681118772!2d90.3466063!3d23.79858275!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sbd!4v1659440129386!5m2!1sen!2sbd"
                allowFullScreen=""
                title="location"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
